// Types
import { BreadcrumbOption } from '../../types/navigation/breadcrumbs';

export const validate = ({ type, onClick }: BreadcrumbOption) => {
  if (type === 'link' && onClick) {
    throw new Error(
      `'onClick' should not be provided when the Breadcrumb 'type' is of 'link'`,
    );
  }
};
